import { render, staticRenderFns } from "./Login_declaracion.vue?vue&type=template&id=784f042b"
import script from "./Login_declaracion.vue?vue&type=script&lang=js"
export * from "./Login_declaracion.vue?vue&type=script&lang=js"
import style0 from "./Login_declaracion.vue?vue&type=style&index=0&id=784f042b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports